import React, { forwardRef } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { openConfirm } from "../../Modal/Confirm";
import Tooltip from "../../Tooltip";
import { reloadTable } from "../reducer";
import axios from "../../../axios";
import { openGeneralErrorNotification } from "../../Notification";

const DeleteItemButton = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { content, route, tableName, disabled, onDelete, children, onOk, className, stopPropagation } = props;
  const dispatch = useDispatch();

  const reloadTableData = () => {
    if (tableName) {
      dispatch(reloadTable({ name: tableName, deleted: true }));
    }
  };

  const openConfirmModal = (e) => {
    e?.preventDefault();

    if (stopPropagation) {
      e.stopPropagation();
    }

    if (disabled) {
      return;
    }

    openConfirm({
      content,
      onOk: () => {
        if (onOk) {
          return onOk();
        }

        return axios.delete(route).then(
          (res) => {
            onDelete?.(res);
            reloadTableData();
          },
          (error) => {
            openGeneralErrorNotification({ error, defaultError: t("container.form_errors.internal_server_error") });
          }
        );
      },
      zIndex: 99999
    });
  };

  const childrenWithClick = children ? React.cloneElement(props.children, { onClick: openConfirmModal }) : null;

  return (
    <Tooltip title={t("container.general_words.delete")} placement="top">
      {childrenWithClick || (
        <button
          ref={ref}
          type="button"
          disabled={disabled}
          onClick={openConfirmModal}
          className={`text-danger ${className || ""}`.trim()}
          style={{ background: "none", border: "none", padding: 0, cursor: disabled ? "not-allowed" : "pointer" }}
        >
          <i className="ti-close" />
        </button>
      )}
    </Tooltip>
  );
});

DeleteItemButton.displayName = "DeleteItemButton";

export default DeleteItemButton;
